import type { ResourceLinkHandler } from "@qw/chat";
import type { MaterialSymbol } from "@qw/ui";
import { useMemo } from "react";
import { useNavigate } from "react-router";
import { useDraftsCompose } from "../providers/use-drafts-compose";

export const useChatResourceLinkHandlers = () => {
  const { openDraft } = useDraftsCompose();
  const navigate = useNavigate();

  const resourceLinkHandlers: Record<string, ResourceLinkHandler> = useMemo(
    () => ({
      draft: {
        icon: "draft" as MaterialSymbol,
        onClick: ({ uri }) => {
          const draftId = uri.split("qw.draft.").pop();
          if (draftId) {
            openDraft(draftId);
          }
        },
        onFirstSeen: ({ uri }) => {
          const draftId = uri.split("qw.draft.").pop();
          if (draftId) {
            openDraft(draftId);
          }
        },
        tooltip: ({ _meta }) => `Open draft${_meta?.subject ? `: ${_meta?.subject}` : ""}`,
      },
      insured: {
        icon: "business" as MaterialSymbol,
        onClick: ({ uri }) => {
          const insuredId = uri.split("qw.insured.").pop();
          if (insuredId) {
            navigate(`/inbox/${insuredId}`);
          }
        },
        tooltip: () => "Open insured",
      },
      opportunity: {
        icon: "folder_open" as MaterialSymbol,
        onClick: ({ uri, _meta }) => {
          const opportunityId = uri.split("qw.opportunity.").pop();
          const insuredId = typeof _meta?.insuredId === "string" ? _meta.insuredId : undefined;
          if (insuredId && opportunityId) {
            navigate(`/inbox/${insuredId}?opportunityId=${opportunityId}`);
          }
        },
        tooltip: () => "Open opportunity",
      },
    }),
    [navigate, openDraft]
  );

  return resourceLinkHandlers;
};
